/**
 * Module dependencies.
 */

import { ifProp, prop } from 'styled-tools';
import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';

/**
 * `SvgProps` type.
 */

export type SvgProps = {
  className?: string;
  color?: string;
  icon: string;
  size: string;
};

/**
 * `Wrapper` styled component.
 */

const Wrapper = styled.span<Omit<SvgProps, 'icon'>>`
  display: inline-block;
  line-height: 0;
  ${ifProp(
    'color',
    css`
      color: ${prop('color')};
    `
  )}
  position: relative;
  width: ${prop('size')};
`;

/**
 * Export `Svg` component.
 */

export const Svg = ({ icon, ...props }: SvgProps) => {
  const innerHtml = useMemo(
    () => ({
      __html: icon // eslint-disable-line id-match
    }),
    [icon]
  );

  return (
    <Wrapper
      {...props}
      dangerouslySetInnerHTML={innerHtml}
    />
  );
};
